module.exports = "https://cdn2-fs.clearscore.com/flux/images/4e74305e48b3cf382d00b567d78667b8.jpg";